import React from "react";
import backArrow from "../../../assets/icons/Back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bettingService from "../../../api/services/bettingService";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { IoIosArrowBack } from "react-icons/io";

const OldMatchesPage = ({ setIsLoading }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { oldHistory } = useSelector(state => state.sidebar);
    const { id } = useParams();
    const { t } = useTranslation();
    const [oldMatches, setOldMatches] = useState([]);
    const language = localStorage.getItem("language");
    const profitAmount = oldHistory ? (oldHistory?.profitAmount >= 0 ? oldHistory.profitAmount : 0) : 0;
    const winAmount = Math.max(profitAmount - (oldHistory?.amount || 0), 0);

    const handleBackClick = async () => {
        dispatch(playSong());
        navigate("/old-histories");
    };

    useEffect(() => {
        setIsLoading(true);
        bettingService.bettingHistoryDetails({
            "gamblingId": Number(id),
            "status": "Finished"
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    const sortedData = data.slice().sort((a, b) => {
                        const dateA = new Date(
                            a.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + a.eventDate.split(' ')[1]
                        );
                        const dateB = new Date(
                            b.eventDate.split(' ')[0].split('-').reverse().join('-') + ' ' + b.eventDate.split(' ')[1]
                        );
                        return dateA - dateB;
                    });
                    setOldMatches(sortedData)
                }
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                console.error("API request error:", err);
            });
    }, [id, navigate, setIsLoading]);

    return (
        <div className="w-full h-[100dvh] flex flex-col bg-slate-100 dark:bg-bg_header_dark overflow-hidden">
            <div className="flex justify-start items-center py-2 border-b dark:border-b dark:border-slate-700 dark:shadow-sm bg-bg_header dark:bg-bg_header_dark">
                <button
                    className="top-3 left-5 w-10 h-10
                    rounded-full drop-shadow-lg flex justify-center items-center text-white text-4xl"
                    onClick={handleBackClick}
                >
                    {/* <img src={backArrow} alt="Back Arrow" /> */}
                    <IoIosArrowBack size={25} />
                </button>
                <div className="flex-1 justify-center items-center">
                    <h3 className="text-white mr-7 text-start ml-2">
                        {t("oldMatches")}
                    </h3>
                </div>
            </div>
            <div className="text-slate-600 dark:text-league_text text-end text-xs mr-3 mt-2 font-medium">BetID : {oldHistory?.postingNo}</div>
            <div className="flex-1 p-1.5 overflow-auto">
                {oldMatches.map((match, index) => {
                    const bettedTeam = language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
                    const oppositeTeamName = language === "en" ? match?.oppositeTeamName : match?.oppositeTeamNameMyan;
                    return (
                        <div key={index} className="flex flex-col py-3 px-1.5 mb-1 rounded-xl bg-white dark:bg-k_groupBgColorEight border border-slate-300 dark:border-slate-700">
                            <div className="flex justify-between items-center mb-1 font-thin text-xs sm:text-sm md:text-base text-k_leagueFgColor dark:text-white">
                                <p className="text-left text-slate-600 dark:text-time_dark font-dangrek px-2">
                                    {match?.eventDate}
                                </p>
                            </div>
                            <div className="grid grid-cols-9 mb-1">
                                <div
                                    className={`${match?.home === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-l-full py-2 px-1 flex items-center col-span-4`}
                                >
                                    <h3
                                        className={`ml-auto font-normal text-center dark:text-white text-sm ${match?.home === true ? "text-k_selectionFgColor" : "text-k_teamsFgColor"
                                            } sm:text-base md:text-base ${match?.isHomeBodyOdd === false
                                                ? "flex flex-1 items-center justify-center"
                                                : "flex flex-1 justify-center"
                                            }`}
                                    >
                                        {match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                    {match.isHomeBodyOdd === true && (
                                        <h3 className="bg-k_priceBgColor p-1 rounded-lg text-k_priceFgColor font-bold text-xxs text-xs sm:text-sm md:text-base whitespace-nowrap">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                </div>
                                <div className="flex justify-center items-center text-white text-center text-xs w-full bg-k_goalscoreBgColor font-dangrek">{`${match?.homeResult}-${match?.awayResult}`}</div>
                                <div
                                    className={`${match?.away === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-r-full py-3 px-1 flex justify-center items-center col-span-4`}
                                >
                                    {match?.isHomeBodyOdd === false && (
                                        <h3 className="bg-k_priceBgColor price p-1 font-bold rounded-lg text-k_priceFgColor text-xxs text-xs sm:text-sm md:text-base">
                                            {match?.bodyOdd}
                                        </h3>
                                    )}
                                    <h3
                                        className={` flex flex-1 w-full justify-center text-center font-normal dark:text-white text-sm sm:text-base md:text-base ${match?.isHomeBodyOdd === true &&
                                            "flex flex-1 justify-center items-center"
                                            }`}
                                    >
                                        {!match.isHome ? bettedTeam : oppositeTeamName}
                                    </h3>
                                </div>
                            </div>
                            <div className="grid grid-cols-9 rounded-full">
                                <div
                                    className={`${match?.overs === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } rounded-l-full p-1 col-span-4`}
                                >
                                    <h3 className="font-normal text-center dark:text-white text-sm sm:text-sm md:text-base py-2">
                                        {t("goalOver")}
                                    </h3>
                                </div>
                                <div className="cursor-not-allowed text-center bg-slate-200 flex justify-center items-center ">
                                    <div className="flex justify-center items-center text-xs h-full px-5 font-bold text-k_priceFgColor whitespace-nowrap">
                                        {match?.goalOdd}
                                    </div>
                                </div>
                                <div
                                    className={`${match?.under === true
                                        ? "bg-k_selectionBgColor text-k_selectionFgColor"
                                        : "bg-k_teamsBgColor text-k_teamsFgColor"
                                        } text-center rounded-r-full p-1 col-span-4 flex justify-center items-center`}
                                >
                                    <h3 className="font-normal text-center  dark:text-white text-sm sm:text-sm md:text-base">
                                        {t("goalUnder")}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="w-full rounded-t-xl bg-bg_header dark:bg-bg_header_dark px-6 py-2 font-dangrek text-white border-t border-slate-500">

                {/* Bet Amount */}
                <div className="flex justify-between items-center py-2 border-b border-white/10">
                    <span className="text-sm opacity-80">
                        {t("betAmount")}
                    </span>
                    <span className="font-semibold">
                        {oldHistory?.amount}
                    </span>
                </div>

                {/* Profit Amount */}
                <div className="flex justify-between items-center py-2 border-b border-white/10">
                    <span className="text-sm opacity-80">
                        {t("profitAmount")}
                    </span>
                    <span className="font-semibold text-yellow-300">
                        {profitAmount}
                    </span>
                </div>

                {/* Win Amount */}
                <div className="flex justify-between items-center py-2">
                    <span className="text-sm opacity-80">
                        {t("winAmount")}
                    </span>
                    <span className="font-bold text-win text-lg">
                        {winAmount}
                    </span>
                </div>

            </div>

        </div>
    );
}

export default OldMatchesPage;
